module.exports = __webpack_public_path__ + "img/ywzt.df0feac0.jpg";